import { liteClient } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { indexName } from '../opts.js';
import { router } from './routing.js';

export const searchClient = liteClient(
	'A5HX6GWR25',
	'a52df830db5a9857faf24c74ce767e41'
);

export const search = instantsearch({
	searchClient,
	indexName,
	routing: {
		router,
	},
	future: {
		preserveSharedStateOnUnmount: true,
		// persistHierarchicalRootCount: boolean,
	}
});

